import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxErrorsModule } from "@ultimate/ngxerrors";
import { AdmissionFormService } from "../admisform/admisformservice";
import { AppRoutingModule } from "../app-routing.module";
import { ComponentModule } from "../components/component.module";
import { AboutComponent } from "./about.component";




@NgModule({

    imports: 
    [ 
        CommonModule,
        FormsModule,
        ComponentModule,
        ReactiveFormsModule,
        NgxErrorsModule,
        AppRoutingModule
        
        
    ],
    
    exports:
    [ 
        AboutComponent
    ],
    
    declarations: 
     [
        AboutComponent
     ],
    
    providers: 
    [
        AdmissionFormService,
        
    ]
  })
  export class AboutModule {}


// WEBPACK FOOTER //
// ./src/app/about/about.module.ts